import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { resolveErrorMessage } from './error-message';
import { ToastService } from './toast/toast.service';
import { AuthService } from 'app/auth/services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const toastService = this.injector.get(ToastService);
        const authService = this.injector.get(AuthService);

        if (error.status === 401) {
          authService.logout();
        } else if (error.status !== 0) {
          const message = resolveErrorMessage(error);
          toastService.danger(message);
        }

        return throwError(() => error);
      })
    );
  }
}
